module.exports = __webpack_public_path__ + "static/6-5cfb5692af75f4f8c2e221e80526f98e.gif";